import React from "react";
import { DisplayDate } from '../../common/DisplayDate';

import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  BooleanField,
  EditButton,
  DeleteButton,
  ImageField,
  Filter,
  ReferenceInput,ShowButton,
  SearchInput,
  SelectField,
  FunctionField 
} from "react-admin";
import CDeleteButton from "../../common/CDeleteButton";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <SearchInput
      variant="outlined"
      label="Bank Name"
      source="name~like"
      alwaysOn
    />
  </Filter>
);

export const RateMasterList = (props) => {
 
  let propsObj = { ...props };
  if (propsObj.permissions) {
    let resourcename = `/${props.resource}`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      let p = myPermissions[0];
      propsObj.hasList = (p.View == 1) ? true : false;
      propsObj.hasShow = (p.View == 1) ? true : false;
      propsObj.hasEdit = (p.Edit == 1) ? true : false;
      propsObj.hasDelete = (p.Delete == 1) ? true : false;
      propsObj.hasCreate = (p.Create == 1) ? true : false;
      propsObj.hasExport = (p.Export == 1) ? true : false;
    }
  }
const col=(props)=>
{
  alert(JSON.stringify(props));
}
  return (
    <List  {...propsObj} exporter={propsObj.hasExport} bulkActionButtons={false} title="Rate Master List"  >
      <Datagrid rowClick={propsObj.hasEdit ? 'edit' :  false}>
        {propsObj.hasEdit && <EditButton />}
        {!propsObj.hasEdit && propsObj.hasShow && <ShowButton />}
        {propsObj.hasDelete && <CDeleteButton {...props}/>}
        <TextField source="name" label="Code" />
        
        
       <ReferenceField label="Policy Department"  link={false} fullWidth={true} source="policyDepartmentId" reference="policy-departments"   > 
           <TextField source="name"  /> 
       </ReferenceField>
          
        <ReferenceField label="Policy Type " link={false} fullWidth={true} source="policyTypeId" reference="policy-types" >
            <TextField source="name"  />
        </ReferenceField>
        
        <TextField source="tpRatePercentage" />
        <TextField source="brokRatePercentage" />
        
        <DisplayDate  source="effectiveFrom" label="Effective From" locales="fr-FR" />
        <ReferenceField source="createdBy" reference="users" label="Created By"  link={false}>
                <TextField source="userName" />
            </ReferenceField>
            <DisplayDate  source="createdDate" label="Created Date" locales="fr-FR" />
            <ReferenceField source="modifyBy" reference="users" label="Updated By"  link={false}>
                <TextField source="userName" />
            </ReferenceField>
            <DisplayDate  source="modifyDate" label="Updated Date" locales="fr-FR" />
      </Datagrid>
    </List>
  );
};
